import React, { FC } from 'react';

import styles from './CardDS.module.scss';

export type CardDSProps = {
  firstContent?: JSX.Element;
  content?: JSX.Element;
  className?: string;
}

export const CardDS: FC<CardDSProps> = ({ firstContent, content, className }) => {
  const computedClassName = [
    styles.container,
    className && className
  ].filter(Boolean).join(' ');

  return (
    <section className={computedClassName}>
      {firstContent}
      {content}
    </section>
  );
};

export default CardDS;
